import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable, throwError as _throw, BehaviorSubject, lastValueFrom} from 'rxjs';
import {SpinnerService} from '@services/spinner.service';

interface IConfig {
  exceptionDetails: boolean;
}

@Injectable()
export class AjaxService {
  debug: boolean = false;
  //config: IConfig;
  config = new BehaviorSubject<IConfig>({} as IConfig);

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private spinnerService: SpinnerService) {
    this.log('AjaxService init!');
  }

  public init() {
    this.get<IConfig>('api/Account/GetConfig').subscribe({
      next: (c) => {
        this.config.next(c);
      },
      error: (err) => {
        throw err;
      },
    });
  }

  public blobToArrayBuffer(blob, cb) {
    const fileReader = new FileReader();
    fileReader.onload = function (event: any) {
      if (cb) {
        cb(event.target.result);
      }
    };
    fileReader.readAsArrayBuffer(blob);
  }

  public downloadResource(url: string): Promise<Blob> {
    const options = this.getRequestHeaders({responseType: 'blob' as 'json'});
    const file = lastValueFrom(this.http.get<Blob>(url, options));
    return file;
  }

  public downloadResourceResponse(url: string): Promise<HttpResponse<Blob>> {
    return lastValueFrom(this.http.get(this.baseUrl + url, {
      headers: this.getRequestHeaders().headers,
      responseType: 'blob',
      observe: 'response',
    }));
  }

  public upload<T>(url: string, input: FormData, cb: (data: T) => void, errCb: (err: any) => void = null) {
    const _headers = this.getRequestHeaders({contentType: false});
    const uploadReq = new HttpRequest('POST', url, input, {
      reportProgress: false,
      headers: _headers.headers,
    });

    this.http.request(uploadReq).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response) {
          const response = event.body as T;
          if (cb) {
            cb(response);
          }
        }
      },
      error: (err) => {
        if (errCb) {
          errCb(err);
        } else {
          this.spinnerService.hide();
          throw new Error(err.error.msg);
        }
      },
    });
  }

  public download(url: string, fileName: string, cb: () => void = null) {
    const blob = this.downloadResource(url);
    blob
      .then((responseBlob) => {
        const url = URL.createObjectURL(responseBlob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          if (cb) {
            cb();
          }
        }, 1000);
      })
      .catch((response) => {
        console.log('catch', response);
      });
  }

  public postDownloadResource(url: string, data: any): Promise<Blob> {
    const options = this.getRequestHeaders({responseType: 'blob' as 'json'});
    return lastValueFrom(this.http.post<Blob>(this.baseUrl + url, data, options));
  }

  public postDownload(url: string, fileName: string, data: any, cb: () => void = null) {
    const blob = this.postDownloadResource(url, data);
    blob
      .then((responseBlob) => {
        const url = URL.createObjectURL(responseBlob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          if (cb) {
            cb();
          }
        }, 1000);
      })
      .catch((response) => {
        console.log('catch', response);
      });
  }

  public getHeadersForDocViewver(): any {
    const user = sessionStorage.getItem('user');
    if (!user) {
      //throw new Error('Kein User im Storage!');
      return;
    }
    const token = JSON.parse(user).token;
    return {
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
    };
  }

  public getRequestHeaders(options: any = null): {headers: HttpHeaders} {
    let headers;

    const user = sessionStorage.getItem('user');
    if (user) {
      const token = JSON.parse(user).token;
      headers = new HttpHeaders({
        Authorization: 'Bearer ' + token,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
      });
    } else {
      headers = new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
      });
    }

    if (options && options.contentType !== null && options.contentType !== undefined && options.contentType !== false) {
      headers.append('Content-Type', options.contentType);
    }
    if (options && options.contentType === false) {
      //console.debug('FileUpload');
    } else {
      headers.append('Content-Type', 'application/json');
    }

    if (options && options.enctype) {
      headers.append('enctype', options.enctype);
    }

    if (options && options.responseType) {
      const result1 = {
        headers: {} as HttpHeaders,
        responseType: {},
      };

      result1.responseType = options.responseType;
      result1.headers = headers;
      return result1;
    } else {
      const result2 = {
        headers: {} as HttpHeaders,
      };
      result2.headers = headers;
      return result2;
    }
  }

  get<T>(path: string): Observable<T> {
    const options = this.getRequestHeaders();
    return this.http.get<T>(this.baseUrl + path, options);
  }

  post<T>(path: string, data: any, options: any = null): Observable<T> {
    const _options = this.getRequestHeaders(options);
    return this.http.post<T>(this.baseUrl + path, data, _options);
  }

  private log(msg: string, paras?: any[]) {
    if (this.debug) {
      console.log(msg, paras);
    }
  }
}
